module.exports = __webpack_public_path__ + "img/experiences2.948c6a93.jpg";